import React, { Component } from 'react'
import {
    Form,
    Modal,
    Row,
    Col,
    Input,
    Button,
    Cascader,
    Tooltip,
    message
} from 'antd'
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import {
    getAllCategories,
    getAllProductCategories
} from '../../../services/apiServices'
import LoadingModal from '../Loading'

class CategorySelectorModal extends Component {
    state = {
        isLoading: false,
        categories: []
    }

    formRef = React.createRef()

    UNSAFE_componentWillReceiveProps(nextProps, prevState) {
        if (nextProps.isOpenModal && !prevState.isOpenModal) {
            this.getCategoryList(nextProps.categoryType)
        }
    }

    async getCategoryList(type) {
        this.setState({ isLoading: true })
        try {
            let categories =
                type == 'POST'
                    ? await getAllCategories()
                    : await getAllProductCategories()
            this.setState({
                isLoading: false,
                categories: this.generateNewList(categories)
            })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    generateNewList(list = []) {
        let newList = list.map(item => generateListObject(item))
        return newList
    }

    filterCategoryPath(inputValue, path) {
        return path.some(
            option =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >
                -1
        )
    }

    onOpenLinkAddMenu() {
        let { categoryType } = this.props
        if (categoryType == 'POST') {
            window.open(window.config.setting.category)
        } else {
            window.open(window.config.setting.productCategory)
        }
    }

    onSubmit() {
        this.formRef.current
            .validateFields()
            .then(values => {
                console.log(values)
                let catId = values.categoryPath[values.categoryPath.length - 1]
                this.formRef.current.resetFields()
                this.props.onSubmit && this.props.onSubmit(catId)
            })
            .catch(info => {
                console.log('Validate Failed:', info)
            })
    }

    render() {
        let { T, isOpenModal, categoryType, onClose } = this.props
        return (
            <Modal
                width={480}
                title={T(
                    categoryType == 'POST'
                        ? 'ARTICLE_CATEGORY'
                        : 'PRODUCT_CATEGORY'
                )}
                centered
                destroyOnClose={true}
                visible={isOpenModal}
                okText={T('OK')}
                cancelText={T('CANCEL')}
                onOk={this.onSubmit.bind(this)}
                onCancel={() => onClose()}>
                <Form ref={this.formRef} name="control-ref">
                    <Input.Group>
                        <Row gutter={10}>
                            <Col span={19}>
                                <Form.Item
                                    name="categoryPath"
                                    rules={[
                                        {
                                            required: true,
                                            message: T('FORM_ERR_REQUIRE')
                                        }
                                    ]}>
                                    <Cascader
                                        style={{ width: '100%' }}
                                        placeholder={T('SELECT_CATEGORY')}
                                        options={this.state.categories}
                                        changeOnSelect
                                        showSearch={{
                                            filter: this.filterCategoryPath.bind(
                                                this
                                            )
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={5} style={{ textAlign: 'center' }}>
                                <Tooltip title={T('RELOAD')}>
                                    <Button
                                        type="primary"
                                        icon={<ReloadOutlined />}
                                        style={{ marginRight: 10 }}
                                        onClick={() =>
                                            this.getCategoryList(categoryType)
                                        }
                                    />
                                </Tooltip>
                                <Tooltip title={T('ADD_CATEGORY')}>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={() => this.onOpenLinkAddMenu()}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </Input.Group>
                </Form>

                <LoadingModal isOpen={this.state.isLoading} />
            </Modal>
        )
    }
}

function generateListObject(item = {}) {
    return {
        value: item.cat_ID,
        label: item.cat_name,
        children:
            item.children && item.children.length > 0
                ? item.children.map(item => generateListObject(item))
                : []
    }
}

export default CategorySelectorModal
